import React, { FC, useEffect, useRef, useState } from 'react';
import type { GameConfig, GameApi, DownedFigures } from '@whitesharx/starfall-frontend-chessground';
import Ground from '../Ground';
import GamePlayerBar from '../GamePlayerBar';
import { PlayerState } from '../../types';
import { EmojiOptions } from '../GamePlayerBar/GamePlayerBar';
import ResignButton from '../GameTools/ResignButton';
import { desktopToolsContainerStyles } from './styles.css';
import { boardStyles, containerStyles, enemyBarStyles, playerBarStyles } from '~/styles/pages/onboarding.css';

type GameLayoutProps = {
  player?: PlayerState;
  enemy?: PlayerState;
  downedFigures?: DownedFigures;
  onSet: (api: GameApi) => void;
  config: GameConfig;
  shownFlash: boolean;
  revenge?: () => void;
  revengePrice?: number;
  onContinue: () => void;
  leave?: () => void;
  onDraw?: () => void;
  onResign?: () => void;
  isGameOver?: boolean;
  emojiOptions?: EmojiOptions;
  isInitialized: boolean;
  isDesktop: boolean;
  isOnboarding: boolean;
  reactOnLittleTime?: boolean;
  pulse?: boolean;
  onTimerEnd?: () => void;
  leaveLoading?: boolean;
};

const GameLayout: FC<GameLayoutProps> = ({
  player,
  enemy,
  downedFigures,
  onSet,
  config,
  shownFlash,
  isGameOver,
  onResign,
  isInitialized,
  emojiOptions,
  isDesktop,
  reactOnLittleTime,
  pulse,
  onTimerEnd,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [showGameTools, setShowGameTools] = useState(false);

  useEffect(() => {
    // to prevent layout issues because of skeleton
    setShowGameTools(Boolean(isDesktop && !isGameOver));
  }, [isGameOver, isDesktop]);

  return (
    <div className={containerStyles} ref={ref}>
      <GamePlayerBar
        className={enemyBarStyles}
        avatarSrc={enemy?.avatarSrc}
        playerName={enemy?.name}
        country={enemy?.country}
        color={player?.color}
        figures={player?.color && downedFigures ? downedFigures[player.color] : undefined}
        figuresSetName={player?.setName}
        setName={enemy?.setName}
        emojiOptions={emojiOptions}
        isDesktop={isDesktop}
        leftTime={enemy?.turnTime}
        pause={enemy?.pause}
        onEnd={onTimerEnd}
      />

      <Ground
        config={config}
        onSet={onSet}
        shownFlash={shownFlash}
        isInitialized={isInitialized}
        className={boardStyles}
        container={ref.current}
      />

      <GamePlayerBar
        className={playerBarStyles}
        avatarSrc={player?.avatarSrc}
        playerName={player?.name}
        country={player?.country}
        color={enemy?.color}
        figures={enemy?.color && downedFigures ? downedFigures[enemy.color] : undefined}
        figuresSetName={player?.setName}
        setName={player?.setName}
        emojiOptions={emojiOptions}
        isDesktop={isDesktop}
        reactOnLittleTime={reactOnLittleTime}
        pulse={pulse}
        leftTime={player?.turnTime}
        pause={player?.pause}
        onEnd={onTimerEnd}
        isPlayer
      />

      {showGameTools && (
        <div className={desktopToolsContainerStyles}>
          <ResignButton onClick={onResign} />
        </div>
      )}
    </div>
  );
};

export default GameLayout;
